<script lang="ts">
    import type { VehicleResponseType } from './types';
    import IconMarkEmailUnread from '../../shared/Icons/IconMarkEmailUnread.svelte';
    import ErrorColor from '../../shared/ErrorColor.svelte';
    import { _ } from 'svelte-i18n';

    export let vehicleName: null | string = null;
    export let styleMode: 'filter' | 'link' = 'filter';
    export let prompt: string = 'select_vehicle';
</script>

<div class="select-vehicle-text select-vehicle-text-{styleMode}" style="line-height: 20px;">
    {#if vehicleName === null}
        <span style="font-weight: 500; line-height: 20px;font-style: italic;">
            {$_(prompt)}
        </span>
    {:else}
        <span style="font-weight: 500; line-height: 20px;">
            {vehicleName}
        </span>
    {/if}
</div>

<style>
    .select-vehicle-text {
        display: flex;
        align-items: center;
        flex-direction: row;
        column-gap: 6px;
        font-size: inherit;
    }
    .select-vehicle-text span {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    .select-vehicle-text-filter {
    }
    .select-vehicle-text-link {
        font-size: 20px;
    }
</style>
